import { render, staticRenderFns } from "./ReportMessageDialog.vue?vue&type=template&id=41194090&scoped=true&"
import script from "./ReportMessageDialog.vue?vue&type=script&lang=js&"
export * from "./ReportMessageDialog.vue?vue&type=script&lang=js&"
import style0 from "./ReportMessageDialog.vue?vue&type=style&index=0&id=41194090&scoped=true&lang=scss&"
import style1 from "./ReportMessageDialog.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41194090",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCol,VRow,VTextarea})
